import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';

export const NAVIGATION_OPEN_QUERY_PARAM = 'navigationOpen';

@Injectable({
  providedIn: 'root',
})
export class MobileNavigationService {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  private checkIfSet(): boolean {
    const urlTree = this.router.parseUrl(this.router.url);
    return !!urlTree.queryParams[NAVIGATION_OPEN_QUERY_PARAM];
  }

  private checkIfOpened(): boolean {
    const urlTree = this.router.parseUrl(this.router.url);
    return urlTree.queryParams[NAVIGATION_OPEN_QUERY_PARAM] === 'true';
  }

  public readonly isQueryParamSet = toSignal(
    this.router.events.pipe(map(() => this.checkIfSet())),
    { initialValue: this.checkIfSet() },
  );

  // Convert the observable to a signal for reactive usage
  public readonly isOpened = toSignal(
    this.router.events.pipe(map(() => this.checkIfOpened())),
    { initialValue: this.checkIfOpened() },
  );

  public async open(): Promise<boolean> {
    return this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { [NAVIGATION_OPEN_QUERY_PARAM]: true },
      queryParamsHandling: 'merge',
    });
  }

  public async close(): Promise<boolean> {
    // Get current query params and remove navigationOpen
    return this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { [NAVIGATION_OPEN_QUERY_PARAM]: null },
      queryParamsHandling: 'merge',
    });
  }

  public async toggle(): Promise<boolean> {
    if (this.isOpened()) {
      return this.close();
    } else {
      return this.open();
    }
  }
}
